import { call, put, takeLatest } from 'redux-saga/effects';
import { captureException } from '@sentry/react';
import { getCustomConfigAPI, getWLCompanyDataAPI } from '../api/whitelabel.api';
import { progressStart, progressStop } from '../actions';
import ActionTypes from '../constants/ActionTypes';
import { DEFAULT_CONFIG } from '../constants/PlatformConstants';
import { whiteLabelEnabled } from '../constants/AppConstants';

function* getWLCompanyData(action) {
  const config = structuredClone(DEFAULT_CONFIG);
  const { testSlug } = action.payload;
  try {
    yield put(progressStart());
    if (whiteLabelEnabled) {
      const resp = yield call(getWLCompanyDataAPI);
      config.faviconUrl =
        resp.data.favicon_icon_url ?? DEFAULT_CONFIG.faviconUrl;
      config.companyLogo =
        resp.data.logo_full_icon_url ?? DEFAULT_CONFIG.companyLogo;
      config.companyDarkLogo =
        resp.data.logo_full_icon_url ?? DEFAULT_CONFIG.companyDarkLogo;
      config.company64x64LOGO =
        resp.data.logo_64X64_icon_url ?? DEFAULT_CONFIG.company64x64LOGO;
      config.companyLogoStyle = resp.data.logo_full_icon_url
        ? {
            marginTop: '-7px',
            height: '56px',
          }
        : DEFAULT_CONFIG.companyLogoStyle;
      config.companySupportEmail =
        resp.data.extra_data.white_label_support_email ??
        DEFAULT_CONFIG.companySupportEmail;
    } else if (testSlug) {
      const resp = yield call(getCustomConfigAPI, testSlug);
      const customConfig = resp.data.custom_config;
      if (customConfig?.enabled) {
        config.companyLogo = customConfig.company_logo || config.companyLogo;
        config.faviconUrl = customConfig.favicon_url || config.faviconUrl;
        config.company64x64LOGO =
          customConfig.company_64x64_logo || config.company64x64LOGO;
        config.companyLogoStyle =
          customConfig.company_logo_style || config.companyLogoStyle;
        config.feedbackConfig = {
          heading:
            customConfig.feedback_config?.heading ||
            config.feedbackConfig.heading,
          description:
            customConfig.feedback_config?.description ||
            config.feedbackConfig.description,
        };
        config.isCustomConfigEnabled = true;
        config.isSinglePageAssessmentStart = !!customConfig.single_page_assessment_start;
      }
    }
  } catch (error) {
    captureException(error);
  } finally {
    yield put({
      type: `${ActionTypes.GET_WHITELABEL_COMPANY_DATA}_SUCCESS`,
      payload: {
        ...config,
        wlCompanyAPICompleted: true,
      },
    });
    yield put(progressStop());
  }
}

export default function* loadWhitelabelSaga() {
  yield takeLatest(ActionTypes.GET_WHITELABEL_COMPANY_DATA, getWLCompanyData);
}
